// TODO: Types are superflous here, TypeScript infers them
export const INDEX: string = `/`;
export const LOGIN: string = `/login`;
export const RESTORE: string = `/RecuperarContraseña`;
export const TWOFALOGIN: string = `/login/2fa`
export const WITHOUTPROTECTED: string = `/withou-protected`;
export const ERROR: string = `*`;
export const ALTA: string = "/Alta";
export const ALTAEMPRESA: string = "/Alta/Empresa";
export const ALTAPARTICULAR: string = "/Alta/Paciente-particular";
export const ALTAPOSTULANTE: string = "/Alta-postulante";
export const ALTAEMPLEADO: string = "/Alta-empleado";
export const FINALMESSAGE: string = "/Alta/Confirmacion";
export const TURNCONFIRMATION: string = "/Confirmacion-turno";
export const TURNCANCELLATION: string = "/Cancelacion-turno";
export const VALIDATEACCOUNT: string = "/Alta/Validar-cuenta"
export const ADDPASSWORD: string = "/Alta/Agregar-password/:id"
export const ADDPASSWORDLN: string = "/Alta/Agregar-password/:id/:type"
export const REMOTELINKCONFIRMARTION: string = "/remote-link-confirmation/:id"
export const PROMOTION: string = "/Promocion";
export const EMPLOYEES: string = "/Empleados";
export const EMPLOYEE_PROFILE: string = "/Perfil/Empleado/*";
export const POSTULANTES: string = "/Postulantes";
export const APPLICANT_PROFILE: string = "/Perfil/Postulante/*";
export const TURNOS: string = "/Turnos";
export const ROLESUSUARIOS: string = "/Roles-de-Usuarios";
export const RESULTADOS: string = "/Resultados";
export const AUSENTISMO: string = "/Ausentismo";
export const FACTURACION: string = "/Administracion";
export const REPORTES: string = "/Reportes";
export const CONFIGURACION: string = "/Configuracion";
export const SEGURIDAD: string = "/Seguridad";
export const ASESOR_RESULTADOS: string = "/Asesor/Resultados";
export const DECJURADA: string = "/Declaracion-jurada/:id";
export const DECJURADAEMPTY: string = "/Declaracion-jurada";
export const CHATBOT: string = "/chatbot/:id";
export const EDITDECJURADA: string = "/Declaracion-jurada/update/:id";
export const CUENTA: string = "/Cuenta";
export const DATOSEMPRESA: string = "/Cuenta/Datos-Empresa";
export const CONTACTOS: string = "/Cuenta/Contactos";
export const SUCURSALES: string = "/Cuenta/Sucursales";
export const CLOSE = "/Close";

//LINKS DE COMPANY ADMIN
export const COMPANY_ADMIN_LINKS = [
  {
    imgSrc: "/images/Dashboard.svg",
    title: "Tablero",
    linkTo: INDEX,
    available: true,
  },
  {
    imgSrc: "/images/Employees.svg",
    title: "Empleados",
    linkTo: EMPLOYEES,
    available: true,
  },
  {
    imgSrc: "/images/Postulantes.svg",
    title: "Postulantes",
    linkTo: POSTULANTES,
    available: true,
  },
  {
    imgSrc: "/images/Turnos.svg",
    title: "Turnos",
    linkTo: TURNOS,
    available: true,
  },
  {
    imgSrc: "/images/Postulantes.svg",
    title: "Roles de usuarios",
    linkTo: ROLESUSUARIOS,
    available: true,
  },
  {
    imgSrc: "/images/Historial.svg",
    title: "Resultados",
    linkTo: RESULTADOS,
    available: true,
  },
  {
    imgSrc: "/images/Ausentismo.svg",
    title: "Ausentismo",
    linkTo: AUSENTISMO,
    available: true,
  },
  {
    imgSrc: "/images/Solicitudes.svg",
    title: "Reportes",
    linkTo: REPORTES,
    available: true,
  },
  {
    imgSrc: "/images/Seguridad.svg",
    title: "Seguridad",
    linkTo: SEGURIDAD,
    available: true,
  },
  {
    imgSrc: "/images/CerrarSesion.svg",
    title: "Cerrar Sesión",
    linkTo: LOGIN,
    available: true,
  },
];

//LINKS DE PACIENTE PARTICULAR
export const PACIENTE_PARTICULAR_LINKS = [
  {
    imgSrc: "/images/Dashboard.svg",
    title: "Tablero",
    linkTo: INDEX,
    available: true,
  },
  {
    imgSrc: "/images/Turnos.svg",
    title: "Turnos",
    linkTo: TURNOS,
    available: true,
  },
  {
    imgSrc: "/images/Historial.svg",
    title: "Resultados",
    linkTo: RESULTADOS,
    available: true,
  },
  {
    imgSrc: "/images/LineaLarga.svg",
    title: "line",
    linkTo: "",
  },
  {
    imgSrc: "/images/Seguridad.svg",
    title: "Seguridad",
    linkTo: SEGURIDAD,
    available: true,
  },
  {
    imgSrc: "/images/CerrarSesion.svg",
    title: "Cerrar Sesión",
    linkTo: LOGIN,
    available: true,
  },

];

export const RRHH_LINKS = [
  {
    imgSrc: "/images/Dashboard.svg",
    title: "Tablero",
    linkTo: INDEX,
    available: true,
  },
  {
    imgSrc: "/images/Employees.svg",
    title: "Empleados",
    linkTo: EMPLOYEES,
    available: true,
  },
  {
    imgSrc: "/images/Postulantes.svg",
    title: "Postulantes",
    linkTo: POSTULANTES,
    available: true,
  },
  {
    imgSrc: "/images/Turnos.svg",
    title: "Turnos",
    linkTo: TURNOS,
    available: true,
  },
  {
    imgSrc: "/images/Historial.svg",
    title: "Resultados",
    linkTo: RESULTADOS,
    available: true,
  },
  {
    imgSrc: "/images/Ausentismo.svg",
    title: "Ausentismo",
    linkTo: AUSENTISMO,
    available: true,
  },
  {
    imgSrc: "/images/Solicitudes.svg",
    title: "Reportes",
    linkTo: REPORTES,
    available: true,
  },
  {
    imgSrc: "/images/Seguridad.svg",
    title: "Seguridad",
    linkTo: SEGURIDAD,
    available: true,
  },
  {
    imgSrc: "/images/CerrarSesion.svg",
    title: "Cerrar Sesión",
    linkTo: LOGIN,
    available: true,
  },
]

export const RRHH_APPOINTMENTS_AND_ABSENTEE_LINKS = [
  {
    imgSrc: "/images/Turnos.svg",
    title: "Turnos",
    linkTo: TURNOS,
    available: true,
  },
  {
    imgSrc: "/images/Ausentismo.svg",
    title: "Ausentismo",
    linkTo: AUSENTISMO,
    available: true,
  },
  {
    imgSrc: "/images/Seguridad.svg",
    title: "Seguridad",
    linkTo: SEGURIDAD,
    available: true,
  },
  {
    imgSrc: "/images/CerrarSesion.svg",
    title: "Cerrar Sesión",
    linkTo: LOGIN,
    available: true,
  },
]

export const RRHH_RESULT_LINKS = [
  {
    imgSrc: "/images/Historial.svg",
    title: "Resultados",
    linkTo: RESULTADOS,
    available: true,
  },
  {
    imgSrc: "/images/Seguridad.svg",
    title: "Seguridad",
    linkTo: SEGURIDAD,
    available: true,
  },
  {
    imgSrc: "/images/CerrarSesion.svg",
    title: "Cerrar Sesión",
    linkTo: LOGIN,
    available: true,
  },
]

export const RRHH_APPOINTMENTS_LINKS = [
  {
    imgSrc: "/images/Dashboard.svg",
    title: "Tablero",
    linkTo: INDEX,
    available: true,
  },
  {
    imgSrc: "/images/Turnos.svg",
    title: "Turnos",
    linkTo: TURNOS,
    available: true,
  },
  {
    imgSrc: "/images/Historial.svg",
    title: "Resultados",
    linkTo: RESULTADOS,
    available: true,
  },
  {
    imgSrc: "/images/Employees.svg",
    title: "Empleados",
    linkTo: EMPLOYEES,
    available: true,
  },
  {
    imgSrc: "/images/Postulantes.svg",
    title: "Postulantes",
    linkTo: POSTULANTES,
    available: true,
  },
  {
    imgSrc: "/images/Seguridad.svg",
    title: "Seguridad",
    linkTo: SEGURIDAD,
    available: true,
  },
  {
    imgSrc: "/images/CerrarSesion.svg",
    title: "Cerrar Sesión",
    linkTo: LOGIN,
    available: true,
  },
]

export const CANDIDATE_APPOINTMENTS_LINKS = [
  {
    imgSrc: "/images/Turnos.svg",
    title: "Turnos",
    linkTo: TURNOS,
    available: true,
  },
  {
    imgSrc: "/images/Postulantes.svg",
    title: "Postulantes",
    linkTo: POSTULANTES,
    available: true,
  },
  {
    imgSrc: "/images/Seguridad.svg",
    title: "Seguridad",
    linkTo: SEGURIDAD,
    available: true,
  },
  {
    imgSrc: "/images/CerrarSesion.svg",
    title: "Cerrar Sesión",
    linkTo: LOGIN,
    available: true,
  },
]

export const RRHH_ABSENTEE_LINKS = [
  {
    imgSrc: "/images/Dashboard.svg",
    title: "Tablero",
    linkTo: INDEX,
    available: true,
  },
  {
    imgSrc: "/images/Employees.svg",
    title: "Empleados",
    linkTo: EMPLOYEES,
    available: true,
  },
  {
    imgSrc: "/images/Ausentismo.svg",
    title: "Ausentismo",
    linkTo: AUSENTISMO,
    available: true,
  },
  {
    imgSrc: "/images/Historial.svg",
    title: "Resultados",
    linkTo: RESULTADOS,
    available: true,
  },
  {
    imgSrc: "/images/Seguridad.svg",
    title: "Seguridad",
    linkTo: SEGURIDAD,
    available: true,
  },
  {
    imgSrc: "/images/CerrarSesion.svg",
    title: "Cerrar Sesión",
    linkTo: LOGIN,
    available: true,
  },
]

export const ADM_ABSENTEE_LINKS = [
  {
    imgSrc: "/images/Ausentismo.svg",
    title: "Ausentismo",
    linkTo: AUSENTISMO,
    available: true,
  },
  {
    imgSrc: "/images/Seguridad.svg",
    title: "Seguridad",
    linkTo: SEGURIDAD,
    available: true,
  },
  {
    imgSrc: "/images/CerrarSesion.svg",
    title: "Cerrar Sesión",
    linkTo: LOGIN,
    available: true,
  },
]

export const ACCOUNTANT_LINKS = [
  {
    imgSrc: "/images/CerrarSesion.svg",
    title: "Cerrar Sesión",
    linkTo: LOGIN,
    available: true,
  },
]

export const ASESOR_LINKS = [
  {
    imgSrc: "/images/Dashboard.svg",
    title: "Tablero",
    linkTo: INDEX,
    available: true,
  },
  {
    imgSrc: "/images/Historial.svg",
    title: "Resultados",
    linkTo: ASESOR_RESULTADOS,
    available: true,
  },
  {
    imgSrc: "/images/Solicitudes.svg",
    title: "Reportes",
    linkTo: REPORTES,
    available: true,
  },
  {
    imgSrc: "/images/Seguridad.svg",
    title: "Seguridad",
    linkTo: SEGURIDAD,
    available: true,
  },
  {
    imgSrc: "/images/CerrarSesion.svg",
    title: "Cerrar Sesión",
    linkTo: LOGIN,
    available: true,
  },
]